import { Header } from "../header/Header";
import { Footer } from "../footer/Footer";

export const Layout = ({ children }: any) => {
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
};
